import { render } from "./reset_password.vue?vue&type=template&id=6095ae17&ts=true"
import script from "./reset_password.vue?vue&type=script&lang=ts"
export * from "./reset_password.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__